export default "__VITE_PUBLIC_ASSET__05ff359c__"